/* ==========================================================================
   WORN OPINIONS — Theme-Interaktionen
   - Voting (1 Stimme pro Produkt und Besucher, lokal persistiert)
   - Controversy-Meter-Aktualisierung
   - Custom Cursor (roter Punkt -> Label)
   - Scroll-Reveal
   - Hero-Slideshow
   - Mobile-Navigation
   - "OPINION ADDED."-Overlay nach dem Warenkorb-Update
   - Sticky Add-to-Cart (mobil)
   Alle Funktionen sind über die Theme-Einstellungen abschaltbar.
   ========================================================================== */

(function () {
  'use strict';

  var CONFIG = window.WOSettings || {};
  var root = document.documentElement;

  /* ---------------------------------------------------------------- Utils */

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isTouch() {
    return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }



  /* ------------------------------------------- Hinzufuegen im Warenkorb */

  /*
   * Dawns quick-add-modal wird innerhalb des Cart-Drawers nicht korrekt
   * initialisiert — sein Konstruktor laeuft dort nicht, modalContent bleibt
   * undefiniert und preprocessHTML bricht ab. Statt an Dawn zu schrauben
   * hier ein eigener, schlanker Weg: Varianten ueber die Shopify-AJAX-API
   * holen, kompakt auswaehlen lassen, ueber /cart/add.js buchen und den
   * Drawer von Dawn neu rendern lassen.
   */
  if (window.customElements && !window.customElements.get('wo-quick-add')) {
    class WoQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.toggle = this.querySelector('[data-wo-quick-add-toggle]');
        this.panel = this.querySelector('[data-wo-quick-add-options]');
        if (!this.toggle) return;

        this.toggle.addEventListener('click', this.onToggle.bind(this));
      }

      get cartDrawer() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      setBusy(busy) {
        this.toggle.disabled = busy;
        this.toggle.classList.toggle('is-busy', busy);
      }

      onToggle() {
        if (parseInt(this.dataset.variantsCount, 10) <= 1) {
          this.add(this.dataset.variantId);
          return;
        }
        if (this.panel && !this.panel.hasAttribute('hidden')) {
          this.panel.setAttribute('hidden', '');
          return;
        }
        this.openOptions();
      }

      openOptions() {
        if (this.product) {
          this.renderOptions();
          return;
        }
        this.setBusy(true);
        fetch('/products/' + this.dataset.handle + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(
            function (product) {
              this.product = product;
              this.renderOptions();
            }.bind(this)
          )
          .catch(
            function () {
              this.showError();
            }.bind(this)
          )
          .finally(
            function () {
              this.setBusy(false);
            }.bind(this)
          );
      }

      renderOptions() {
        var product = this.product;
        var html = '';

        product.options.forEach(function (option, index) {
          var name = typeof option === 'string' ? option : option.name;
          var values = typeof option === 'string' ? product.variants.map(function (v) { return v['option' + (index + 1)]; }) : option.values;
          var unique = values.filter(function (v, i, arr) {
            return arr.indexOf(v) === i;
          });
          html +=
            '<label class="wo-quick-add__field"><span class="wo-quick-add__label">' +
            name +
            '</span><select class="wo-quick-add__select" data-option-index="' +
            index +
            '">' +
            unique
              .map(function (v) {
                return '<option value="' + v.replace(/"/g, '&quot;') + '">' + v + '</option>';
              })
              .join('') +
            '</select></label>';
        });

        html +=
          '<button class="wo-quick-add__confirm" type="button" data-wo-quick-add-confirm>' +
          (this.dataset.labelConfirm || 'In den Warenkorb') +
          '</button><p class="wo-quick-add__msg" data-wo-quick-add-msg hidden></p>';

        this.panel.innerHTML = html;
        this.panel.removeAttribute('hidden');

        var confirm = this.panel.querySelector('[data-wo-quick-add-confirm]');
        confirm.addEventListener('click', this.onConfirm.bind(this));
        Array.prototype.forEach.call(
          this.panel.querySelectorAll('.wo-quick-add__select'),
          function (select) {
            select.addEventListener('change', this.updateAvailability.bind(this));
          }.bind(this)
        );
        this.updateAvailability();
      }

      selectedVariant() {
        var chosen = Array.prototype.map.call(this.panel.querySelectorAll('.wo-quick-add__select'), function (s) {
          return s.value;
        });
        return this.product.variants.filter(function (variant) {
          return chosen.every(function (value, i) {
            return variant.options[i] === value;
          });
        })[0];
      }

      updateAvailability() {
        var variant = this.selectedVariant();
        var confirm = this.panel.querySelector('[data-wo-quick-add-confirm]');
        var ok = !!(variant && variant.available);
        confirm.disabled = !ok;
        confirm.textContent = ok
          ? this.dataset.labelConfirm || 'In den Warenkorb'
          : this.dataset.labelUnavailable || 'Nicht verfügbar';
      }

      onConfirm() {
        var variant = this.selectedVariant();
        if (!variant || !variant.available) return;
        this.add(variant.id);
      }

      showError() {
        var msg = this.panel && this.panel.querySelector('[data-wo-quick-add-msg]');
        if (!msg) return;
        msg.textContent = this.dataset.labelError || 'Hat nicht geklappt. Bitte erneut versuchen.';
        msg.removeAttribute('hidden');
      }

      add(variantId) {
        if (!variantId) return;
        this.setBusy(true);

        var drawer = this.cartDrawer;
        var body = { items: [{ id: Number(variantId), quantity: 1 }] };

        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (section) {
            return section.section || section.id;
          });
          body.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(
            function (response) {
              if (response.status) {
                this.showError();
                return;
              }
              document.dispatchEvent(new CustomEvent('wo:added'));
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.renderContents(response);
              } else {
                window.location.reload();
              }
            }.bind(this)
          )
          .catch(
            function () {
              this.showError();
            }.bind(this)
          )
          .finally(
            function () {
              this.setBusy(false);
            }.bind(this)
          );
      }
    }

    window.customElements.define('wo-quick-add', WoQuickAdd);
  }


  /* -------------------------------------------------------- Scroll-Reveal */

  function initReveal() {
    if (!CONFIG.scrollReveal || prefersReducedMotion() || !('IntersectionObserver' in window)) return;

    var targets = document.querySelectorAll('.wo-reveal');
    if (!targets.length) return;

    root.classList.add('wo-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    Array.prototype.forEach.call(targets, function (target) {
      var rect = target.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        target.classList.add('is-in');
        return;
      }
      observer.observe(target);
    });
  }

  /* ------------------------------------------------------ Hero-Slideshow */

  function initHero(scope) {
    var heroes = (scope || document).querySelectorAll('[data-wo-hero]');
    Array.prototype.forEach.call(heroes, function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-wo-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-wo-hero-dot]'));
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var delay = parseInt(hero.dataset.woHeroInterval, 10) || 0;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function start() {
        if (!delay || prefersReducedMotion()) return;
        stop();
        timer = window.setInterval(function () {
          show(index + 1);
        }, delay);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      show(0);
      start();
    });
  }

  /* ----------------------------------------------------- Mobile-Navigation */

  /*
   * Das Menue faehrt von links ein. Waehrend es offen ist, darf die Seite
   * dahinter nicht mitscrollen, Escape muss schliessen, und der Fokus
   * gehoert in die Schublade — sonst tabbt man blind hinter dem Overlay.
   */
  function initNav(scope) {
    var toggles = (scope || document).querySelectorAll('[data-wo-nav-toggle]');
    Array.prototype.forEach.call(toggles, function (toggle) {
      if (toggle.dataset.woBound === 'true') return;
      toggle.dataset.woBound = 'true';

      var nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!nav) return;

      /*
       * Der Fokus wandert nur mit, wenn die Tastatur im Spiel war. Sonst
       * legte sich nach jedem Tippen ein roter Fokusring um das X und
       * danach um den Burger - fuer die Tastatur richtig, mit dem Finger
       * nur stoerend. Ein Klick per Tastatur meldet detail === 0, ein
       * Zeiger- oder Fingertipp meldet 1 oder mehr.
       */
      function schliesse(perTastatur) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('wo-nav-open');
        if (perTastatur) toggle.focus();
      }

      function oeffne(perTastatur) {
        nav.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('wo-nav-open');
        if (!perTastatur) return;
        var erstes = nav.querySelector('input, a, button');
        if (erstes) erstes.focus();
      }

      toggle.addEventListener('click', function (event) {
        var perTastatur = event.detail === 0;
        if (nav.classList.contains('is-open')) schliesse(perTastatur);
        else oeffne(perTastatur);
      });

      Array.prototype.forEach.call(nav.querySelectorAll('[data-wo-nav-close]'), function (el) {
        el.addEventListener('click', function (event) {
          schliesse(event.detail === 0);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && nav.classList.contains('is-open')) schliesse(true);
      });
    });
  }

  /* ---------------------------------------------------------------- Overlay */

  /*
   * Ein Overlay, geoeffnet ueber [data-wo-modal-open="ID"], geschlossen
   * ueber [data-wo-modal-close], Escape oder Klick daneben. Dieselben
   * Regeln wie beim Menue: Seite dahinter sperren, Fokus hinein.
   *
   * Shopifys Kundenformular laedt die Seite neu. Traegt das Overlay danach
   * data-wo-modal-open-on-load, geht es von selbst wieder auf — sonst
   * verschwaende die Bestaetigung hinter einem geschlossenen Fenster.
   */
  function initModals(scope) {
    var wurzel = scope || document;

    Array.prototype.forEach.call(wurzel.querySelectorAll('[data-wo-modal-open]'), function (knopf) {
      if (knopf.dataset.woBound === 'true') return;
      knopf.dataset.woBound = 'true';
      knopf.addEventListener('click', function (event) {
        oeffne(document.getElementById(knopf.dataset.woModalOpen), knopf, event.detail === 0);
      });
    });

    Array.prototype.forEach.call(wurzel.querySelectorAll('.wo-modal'), function (modal) {
      if (modal.dataset.woBound === 'true') return;
      modal.dataset.woBound = 'true';

      Array.prototype.forEach.call(modal.querySelectorAll('[data-wo-modal-close]'), function (el) {
        el.addEventListener('click', function (event) {
          schliesse(modal, event.detail === 0);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) schliesse(modal, true);
      });

      // Nach dem Absenden traegt die Bestaetigung im Formular die Marke.
      if (modal.querySelector('[data-wo-modal-open-on-load]')) oeffne(modal, null, false);
    });

    // Fokus nur bei Tastaturbedienung setzen, siehe initNav.
    function oeffne(modal, ausloeser, perTastatur) {
      if (!modal) return;
      modal.woAusloeser = ausloeser;
      modal.classList.add('is-open');
      document.documentElement.classList.add('wo-nav-open');
      if (!perTastatur) return;
      var erstes = modal.querySelector('input, button, a');
      if (erstes) erstes.focus();
    }

    function schliesse(modal, perTastatur) {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('wo-nav-open');
      if (perTastatur && modal.woAusloeser) modal.woAusloeser.focus();
    }
  }

  /* -------------------------------------------- "OPINION ADDED."-Overlay */

  function initFlash() {
    if (!CONFIG.flashOnAdd) return;

    var flash = document.querySelector('[data-wo-flash]');
    if (!flash) return;

    var timer = null;

    function show() {
      flash.classList.add('is-active');
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        flash.classList.remove('is-active');
      }, parseInt(CONFIG.flashDuration, 10) || 1200);
    }

    // Dawn veröffentlicht 'cart-update' über pubsub.js. PUB_SUB_EVENTS ist dort
    // ein const im globalen Lexical Scope und liegt deshalb nicht auf window —
    // der Zugriff muss über den blanken Bezeichner laufen.
    var events = null;
    try {
      /* eslint-disable-next-line no-undef */
      events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    } catch (e) {
      events = null;
    }

    var cartUpdateEvent = (events && events.cartUpdate) || 'cart-update';

    if (typeof window.subscribe === 'function') {
      window.subscribe(cartUpdateEvent, function (event) {
        if (!event || event.source === 'product-form' || event.source === 'quick-add') show();
      });
    }

    document.addEventListener('wo:added', show);
  }

  /* ------------------------------------------------- Sticky Add-to-Cart */

  function initStickyAtc(scope) {
    var bars = (scope || document).querySelectorAll('[data-wo-sticky-atc]');
    if (!bars.length) return;

    // Platz am Seitenende schaffen, sonst verdeckt die Leiste den Fuss.
    document.body.classList.add('wo-has-sticky-atc');

    Array.prototype.forEach.call(bars, function (bar) {
      var button = bar.querySelector('[data-wo-sticky-submit]');
      if (button && button.dataset.woBound !== 'true') {
        button.dataset.woBound = 'true';
        button.addEventListener('click', function () {
          // Section-ID unbekannt: das Produktformular der Seite wird gesucht.
          var form = document.querySelector('product-form form, form[action$="/cart/add"]');
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      }

      var anchor = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!anchor || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      observer.observe(anchor);
    });
  }

  /* ------------------------------------------------------------- Marquee */

  function initMarquee(scope) {
    var marquees = (scope || document).querySelectorAll('[data-wo-marquee]');
    Array.prototype.forEach.call(marquees, function (marquee) {
      var track = marquee.querySelector('.wo-marquee__track');
      if (!track) return;
      var items = track.children;
      // Zweite Hälfte für den nahtlosen Loop sicherstellen.
      if (items.length === 1) track.appendChild(items[0].cloneNode(true));
    });
  }

  /* ------------------------------------------------------------- Countdown */

  /*
   * Die Restzeit steht schon serverseitig im HTML und ist damit auch ohne
   * JavaScript richtig. Hier laeuft sie nur weiter. Geschrieben wird nur,
   * was sich geaendert hat: sonst tauscht jede Sekunde die ganze Leiste.
   */
  if (window.customElements && !window.customElements.get('wo-countdown')) {
    class WoCountdown extends HTMLElement {
      connectedCallback() {
        this.until = parseInt(this.dataset.until, 10) || 0;
        this.units = Array.prototype.slice.call(this.querySelectorAll('[data-wo-digits]'));
        if (!this.until || this.units.length !== 4) return;
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
      }

      tick() {
        var rest = this.until - Math.floor(Date.now() / 1000);
        if (rest <= 0) {
          // Ein Countdown auf null sieht aus wie ein Fehler.
          if (this.timer) window.clearInterval(this.timer);
          this.remove();
          return;
        }
        var werte = [
          this.pad(Math.floor(rest / 86400), 3),
          this.pad(Math.floor((rest % 86400) / 3600), 2),
          this.pad(Math.floor((rest % 3600) / 60), 2),
          this.pad(rest % 60, 2)
        ];
        for (var i = 0; i < 4; i++) this.schreibe(this.units[i], werte[i]);
      }

      pad(zahl, stellen) {
        var s = String(zahl);
        while (s.length < stellen) s = '0' + s;
        return s;
      }

      schreibe(behaelter, wert) {
        var zellen = behaelter.children;
        if (zellen.length !== wert.length) {
          behaelter.textContent = '';
          for (var i = 0; i < wert.length; i++) {
            var span = document.createElement('span');
            span.className = 'wo-dropbar__digit';
            span.textContent = wert[i];
            behaelter.appendChild(span);
          }
          return;
        }
        for (var j = 0; j < wert.length; j++) {
          if (zellen[j].textContent !== wert[j]) zellen[j].textContent = wert[j];
        }
      }
    }

    window.customElements.define('wo-countdown', WoCountdown);
  }

  /* ---------------------------------------------------------------- Boot */

  function boot(scope) {
    initHero(scope);
    initNav(scope);
    initModals(scope);
    initMarquee(scope);
    initStickyAtc(scope);
  }

  ready(function () {
    boot(document);
    initReveal();
    initFlash();
  });

  // Theme-Editor: Sections werden neu geladen.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    initReveal();
  });
})();
